export default "__VITE_ASSET__BxV1lMz___"